/* no babel so we have to use old js syntax */
window.Popper = require("popper.js");
require("bootstrap");

import "@fontsource/orbitron/latin.css";
import "@fontsource/poppins/latin.css";

import { gsap, ScrollTrigger, MotionPathPlugin } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MotionPathPlugin);
//import './animations/animations';

let mm = gsap.matchMedia();

const scrollToStartElems = gsap.utils.toArray('main > section:first-child');
scrollToStartElems.forEach(section => {
  let sectionTimeline = gsap.timeline({
    scrollTrigger: {
      start: 'top',
      end: 'top+=10%',
      trigger: section,
      scrub: true
    }
  });

  sectionTimeline.fromTo(
    section.querySelector('.sts'),
    {opacity: 1, filter: "blur(0px)"},
    {opacity: 0, filter: "blur(10px)"}
  )
});



const eyeToClearSections = gsap.utils.toArray('.eye-to-clear-after');
eyeToClearSections.forEach(section => {
  let sectionTimeline = gsap.timeline({
    scrollTrigger: {
      start: 'top',
      end: 'bottom-=30%',
      trigger: section,
      scrub: true,
      //markers: true
    }
  });

  sectionTimeline.fromTo(
    section,
    {background: "radial-gradient(circle, rgba(33,33,33,0) 25%, rgba(33,33,33,1) 25%)"},
    {background: "radial-gradient(circle, rgba(33,33,33,0) 100%, rgba(33,33,33,0) 100%)"}
  )
});


const fadeInSections = gsap.utils.toArray('section.fadein');
fadeInSections.forEach(section => {
  let sectionTimeline = gsap.timeline({
    scrollTrigger: {
      start: 'top',
      end: 'bottom',
      trigger: section,
      scrub: true,
      pin: true,
      //markers: true
    }
  });

  sectionTimeline.fromTo(
    section,
    {opacity: 0, filter: "blur(10px)", width: "10%"},
    {opacity: 1, filter: "blur(0px)", width: "100%"}
  )
});


const aroundTheWorldSections = gsap.utils.toArray('section.aroundTheWorld');
aroundTheWorldSections.forEach(section => {

  let sectionTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top",
      end: "+=2500",
      scrub: true,
      pin: true,
      marker: true
    }
  });
  let images = gsap.utils.toArray(section.querySelectorAll('.list-group-item picture'));
  images.forEach((image, number) => {

    sectionTimeline.fromTo(
      image,
      {opacity: 0},
      {
        opacity: 1, motionPath: {
          path: "#circle",
          align: "#circle",
          autoRotate: false,
          alignOrigin: [0.5, 0.5],
          end: (0.80 - number * 0.15)
        }
      }
    )
  });
});

const slideInFromLeftSections = gsap.utils.toArray('section.slideInFromLeft');
slideInFromLeftSections.forEach(section => {
  let sectionTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top bottom",
      end: "bottom center",
      scrub: true
    }
  });

  sectionTimeline.fromTo(
    section,
    {position: "relative", left: "-100vw"},
    {position: "relative", left: "0"}
  )
});


mm.add("(min-width: 1140px)", () => {



  const fadeInFlowSections = gsap.utils.toArray('section.fadeInFlow');
  fadeInFlowSections.forEach(section => {
    let sectionTimeline = gsap.timeline({
      scrollTrigger: {
        start: 'top bottom',
        end: 'bottom bottom',
        trigger: section,
        scrub: true,
        //markers: true
      }
    });

    sectionTimeline.fromTo(
      section,
      {opacity: 0, filter: "blur(10px)"},
      {opacity: 1, filter: "blur(0px)"}
    )
  });


  const imageFlyBySections = gsap.utils.toArray('section.imageFlyBy');
  imageFlyBySections.forEach(section => {
    let sectionTimeline = gsap.timeline({
      scrollTrigger: {
        start: 'top',
        end: 'bottom',
        trigger: section,
        scrub: true,
        //markers: true,
        pin: true
      }
    });

    let imageFlyByImages = gsap.utils.toArray(section.querySelectorAll('img'));
    sectionTimeline.fromTo(imageFlyByImages, {
        opacity: 0
      },
      {
        opacity: 1,
        motionPath: {
          path: "M 0 -150 A 150 150 0 0 0 0 150", // SVG Arc-Path
          autoRotate: false
        }
      });
  });



  const imageImplodeSections = gsap.utils.toArray('section.imageImplode');
  imageImplodeSections.forEach(section => {

    let sectionTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: '+=2000',
        scrub: true,
        pin: true
      }
    });

    let images = gsap.utils.toArray(section.querySelectorAll('picture'));

    sectionTimeline.fromTo(
      images[0],
      {opacity: 0, top: "-100vh", filter: "blur(10px)"},
      {opacity: 1, top: "0", filter: "blur(0px)"}
    )

    sectionTimeline.fromTo(
      images[1],
      {opacity: 0, filter: "blur(10px)", bottom: "-100vh"},
      {opacity: 1, filter: "blur(0px)", bottom: "0"}
    )

    if (section.classList.contains('content-align-right')) {
      sectionTimeline.fromTo(
        images[2],
        {opacity: 0, filter: "blur(10px)", left: "-100vw"},
        {opacity: 1, filter: "blur(0px)", left: "0"}
      )
    } else {
      sectionTimeline.fromTo(
        images[2],
        {opacity: 0, filter: "blur(10px)", right: "-100vw"},
        {opacity: 1, filter: "blur(0px)", right: "0"}
      )
    }
  });

  const imagesAnimationSections = gsap.utils.toArray('section.imagesAnimation');
  imagesAnimationSections.forEach(section => {

    let sectionTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: '+=2000',
        scrub: true,
        pin: true
      }
    });

    let images = gsap.utils.toArray(section.querySelectorAll('picture'));

    images.forEach(image => {
      sectionTimeline.fromTo(
        image,
        {opacity: 0, filter: "blur(10px)"},
        {opacity: 1, filter: "blur(0px)"}
      )
    });

  });


  const flyInLeftAndRightSections = gsap.utils.toArray('section.flyInLeftAndRight');

  flyInLeftAndRightSections.forEach(section => {
    let sectionTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: true
      }
    });

    if (section.classList.contains('content-align-right')) {
      var evenCols = gsap.utils.toArray(section.querySelectorAll('.row div:nth-child(odd)'));
      var oddCols = gsap.utils.toArray(section.querySelectorAll('.row div:nth-child(even)'));

    } else {

      var oddCols = gsap.utils.toArray(section.querySelectorAll('.row div:nth-child(odd)'));
      var evenCols = gsap.utils.toArray(section.querySelectorAll('.row div:nth-child(even)'));
    }

    sectionTimeline.fromTo(
      oddCols,
      {opacity: 0, left: "-50vw", filter: "blur(10px)"},
      {opacity: 1, left: "0", filter: "blur(0px)"}
    )

    sectionTimeline.fromTo(
      evenCols,
      {opacity: 0, filter: "blur(10px)", right: "-50vw"},
      {opacity: 1, filter: "blur(0px)", right: "0"}
    )
  });


  const flyInLeftAndRightCardSections = gsap.utils.toArray('section.flyInLeftAndRightCard');
  flyInLeftAndRightCardSections.forEach(section => {

    let sectionTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "bottom top",
        scrub: true,
        pin: true
      }
    });

    if (section.classList.contains('content-align-right')) {
      var evenCards = gsap.utils.toArray(section.querySelectorAll('.row-boxes div:nth-child(odd) .card'));
      var oddCards = gsap.utils.toArray(section.querySelectorAll('.row-boxes div:nth-child(even) .card'));
    } else {
      var oddCards = gsap.utils.toArray(section.querySelectorAll('.row-boxes div:nth-child(odd) .card'));
      var evenCards = gsap.utils.toArray(section.querySelectorAll('.row-boxes div:nth-child(even) .card'));

    }

    sectionTimeline.fromTo(
      oddCards,
      {opacity: 0, left: "-50vw", filter: "blur(10px)"},
      {opacity: 1, left: "0", filter: "blur(0px)"}
    )

    sectionTimeline.fromTo(
      evenCards,
      {opacity: 0, filter: "blur(10px)", right: "-50vw"},
      {opacity: 1, filter: "blur(0px)", right: "0"}
    )
  });




  const scrollCardsHorizontalSections = gsap.utils.toArray('section.scrollCardsHorizontal');
  scrollCardsHorizontalSections.forEach(section => {

    let cards = gsap.utils.toArray(section.querySelectorAll('.row-boxes > div'));
    gsap.to(cards, {
      xPercent: -100 * (cards.length - 1),
      scrollTrigger: {
        start: 'top top',
        end: '+=7000',
        //end: 'bottom',
        trigger: section,
        scrub: true,
        pin: true,
        //markers: true
      }
    })
  });
});

ScrollTrigger.sort();

$(function () {
  // Create scoll markers for each section
  const sections = document.querySelectorAll("section");
  // Wenn der Key sections[scene.start] nicht verfügbar ist, filtere die scene raus
  const filteredScenes = scenes.filter((scene) => sections[scene.start]);
  const scenesWithOffets = filteredScenes.map((scene, i) => {
    const start =
      i > 0
        ? sections[scene.start].getBoundingClientRect().top + window.scrollY
        : 0;
    const documentHeight = document.body.scrollHeight;
    const viewportHeight = window.innerHeight;
   //console.log(!!sections[scene.end]);
    const end =
      scene.end && !!sections[scene.end]
        ? sections[scene.end].getBoundingClientRect().bottom + window.scrollY
        : documentHeight - viewportHeight;
    scene.start = start;
    scene.end = end;
    return scene;
  });

  function determineCurrentScene() {
    const currentScene = scenesWithOffets.findIndex((scene) => {
      return (
        window.scrollY >= scene.start &&
        (scene.end ? window.scrollY <= scene.end : true)
      );
    });

    //console.log("Current Scene: ", currentScene);

    try {
      const currentSceneProgress =
        (window.scrollY - scenesWithOffets[currentScene].start) /
        (scenesWithOffets[currentScene].end -
          scenesWithOffets[currentScene].start);
      const currentFrame = Math.floor(
        currentSceneProgress * (scenesWithOffets[currentScene].images.length)
      );
      const frameAmount = scenesWithOffets[currentScene].images.length - 1;
      const absToBottom = Math.abs(currentFrame - frameAmount);
      const absToTop = Math.abs(currentFrame);
      var abs = 100
      if(currentScene === 0) {
        abs = absToBottom;
      } else if (currentScene === scenesWithOffets.length -1) {
        abs = absToTop;
      } else {
        abs = Math.min(absToBottom, absToTop);
      }
      //console.log(abs);
      const currentImage = scenesWithOffets[currentScene].images[currentFrame];
      // Set the  right image element as child of the animation container
      const animationContainer = document.querySelector(".animation-container");
      const opacityProvider = document.querySelector(".animation-opacity-provider");

      if(abs < 4) {
        opacityProvider.style.opacity = 1;
      } else {
        opacityProvider.style.opacity = 0.4;
      }
      if(currentImage) {
        animationContainer.src = currentImage;
      }
    } catch (e) {
    }

    /*
    const overlaySceneStart = scenesWithOffets[overlay.startScene - 1].start;
    const overlaySceneEnd = scenesWithOffets[overlay.startScene - 1].end;
    const overlayStart =
      overlaySceneStart +
      (overlaySceneEnd - overlaySceneStart) * (overlay.startProgress / 100);
    const overlayEnd =
      overlayStart + overlay.images.length * overlay.pixelsPerFrame;
    const overlayContainer = document.querySelector(
      ".animation-overlay-container"
    );

    if (window.scrollY >= overlayStart && window.scrollY <= overlayEnd) {
      overlayContainer.style.display = "block";
      const overlayProgress = (window.scrollY - overlayStart) / (overlayEnd - overlayStart);
      const overlayImage = overlay.images[Math.floor(overlayProgress * overlay.images.length)];
      overlayContainer.src = overlayImage;
      console.log(overlayImage);
    } else {
      // Add display: none to the overlay container
      overlayContainer.src = "";
      overlayContainer.style.display = "none";
    }
    */
  }
  // Get all sections that are children of the main tag
  determineCurrentScene();
  // Listen for scroll events
  window.addEventListener("scroll", determineCurrentScene);
});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 6
// module chunks = 0